/**
 * Component Registry for Terminal 21
 * 
 * Inherits from @vibesites-aion-management/theme-stadium-house and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-aion-management/theme-stadium-house/registry';
import { Hero } from './components/Hero';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
